/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const creteMessageModelSchema = z.object({
    "text": z.string().max(2000).describe("Текст сообщения").nullable().nullish(),
"attachmentId": z.string().uuid().describe("Идентификатор файла-вложения").nullable().nullish()
    })